<template>
  <div class="bt">
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
export default {
  name: 'PageFaceTreeLayout',
  computed: {
    key() {
      return this.$route.path + Math.random()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (+to.params.id === 0) {
      this.$store.commit('setHistory', [])
    }
    next()
  }
}
</script>

<style lang="sass" scoped></style>
